module.exports = __webpack_public_path__ + "img/icon.cb16774a.png";